export default class MiniGamesBadgeRequirements {
  public participationCount: number;
  public fromDate: string;
  public toDate: string;
}
